import { createContext, useContext } from 'react';
 
export const PillContext = createContext(null);
 
export function usePill() {
  const context = useContext(PillContext);
  if (!context) {
    throw new Error('usePill must be used within a SearchResultDropdownPill provider');
  }
  return context;
}
